const CUSTOM_LISTS = {
    LIST_FAVORITES: '/list/favorites',
    LIST_HISTORY: '/list/history',
    LIST_WATCHLATER: '/list/watch-later',
};

// shorthand from Tour/MA
const getPathToRoute = ({ routesMap, path, customPath }) => {
    let route;
    if ((!path || path === 'custom') && customPath) {
        route = customPath;
    } else if (path === 'openDrawer') {
        route = '#drawer';
    } else if (path.type) {
        route = routesMap[path.type];
        if (path.payload) {
            const { actor, release } = path.payload;
            if (actor) {
                route = route.replace(/\{\{actor\.([^}]+)\}\}/g, (part1, part2) => actor[part2] || '');
            }
            if (release) {
                route = route.replace(/\{\{release\.([^}]+)\}\}/g, (part1, part2) => release[part2] || '');
            }
        }
        if (path.query) {
            const queryParams = new URLSearchParams(path.query);
            route += `?${queryParams}`;
        }
    } else if (Object.keys(CUSTOM_LISTS).includes(path)) {
        route = CUSTOM_LISTS[path];
    } else if (routesMap[path]) {
        route = routesMap[path];
    }
    return route;
};

const queryToString = query => {
    const arr = Object.keys(query).reduce((acc, key) => ([
        ...acc,
        `${key}=${query[key]}`,
    ]), []);
    return arr.length > 0 ? '?'.concat(arr.join('&')) : '';
};

export {
    getPathToRoute,
    queryToString,
};
